import { AfterViewInit, Component, assertPlatform } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { CustomServiceService } from '../../service/custom-service.service';

import { TranslateService } from '@ngx-translate/core';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css']
})
export class StockComponent implements AfterViewInit {

  public ngAfterViewInit(): void {
    this.createChartColumn();
   
  this.start=(this.currentPage - 1)*this.limit;
  
    this.getStockList('','',this.start,this.limit,this.currentPage);
  }

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService,private route: Router,public translate: TranslateService) {
   
    this.years = this.generateYears(new Date().getFullYear(), 2012);
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
    
    };
  
  ngOnInit(): void {
    this.selectedYear = new Date().getFullYear();
    this.start=(this.currentPage - 1)*this.limit;
    this.getStockList('',this.selectedYear,this.start,this.limit,this.currentPage);
    this.getStockStateUTList();
    this.getStockDateUTList();
    this.createChartColumn();
    
  }
  getStockData:any=[];
  language: any = sessionStorage.getItem('locale'); 
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:number=0;
  RefreshBtn:boolean=false;
  ShowTabView : boolean =false;
  currentYear: number;
  Toggle(boolean: boolean){
    this.ShowTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#stockchart').addClass('active');
    } else {
      $('#stocktbl').addClass('active');
    }
  }
  


  private getRandomNumber(min: number, max: number, centralTotalStock: number): number {
    return Math.floor(centralTotalStock)
  }

  public mapStockDataToCategories(stockData: any[]): number[] {
    
    const categories: string[] = [];
  this.StateUTList.forEach((item: { state_English: string; }) => {
    categories.push(item.state_English);
  });
  
    const amounts: number[] = [];
  
    for (const category of categories) {
      const stateData = stockData.find(item => item.state_English === category);
      if (stateData) {
        amounts.push(stateData.central_total_stock);
      } else {
        amounts.push(0);
      }
    }
    return amounts;
  }
  stockAmount:any;
  public createChartColumn(): void {
    if(this.selectedState == ''){
    this.stockAmount = this.mapStockDataToCategories(this.getStockData);
    let date = new Date();
    const data: any[] = [];
    const categories: string[] = [];
  this.StateUTList.forEach((item: { state_English: string; }) => {
  categories.push(item.state_English);
   });
    for (let i = 0; i < categories.length; i++) {
      date.setDate(new Date().getDate() + i);
      const stockItem = this.getStockData[i];

      const centralTotalStock = stockItem?.central_total_stock ?? 0;
        data.push({          
          y: this.getRandomNumber(0, 10000, this.stockAmount[i]),
        });
    }

    const chart = Highcharts.chart('chart-stock' as any, {
    
      title: {
        text: this.language === 'English' ? 'Stock' : 'भंडार'
      },
      chart: {
        type: 'column',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      
      yAxis: {
        min: 0,
        title: undefined,
      },
     
      xAxis: {
        categories: this.StateUTList.map((item: { state_English: any;state_Hindi :any;}) => this.language === 'English' ? item.state_English : item.state_Hindi),
      },
      tooltip: {
        // headerFormat: `<div>Date: {point.key}</div>`,
        headerFormat: '',
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        },
      series: [{
        name: 'Amount',
        data,
 color: '#006637'
      }],
    } as any);
    
  }else{
    this.stockAmount = this.mapStockDateData(this.getStockData);
    let date = new Date();
    const data: any[] = [];
    const categories: string[] = [];
  this.DateUTList.forEach((item: { date: string; }) => {
  categories.push(item.date);
   });
    // 
    // const amounts: number[] = [];
    // console.log(this.getStockData);
    for (let i = 0; i < categories.length; i++) {
      // console.log(amounts[i]);
      date.setDate(new Date().getDate() + i);
      const stockItem = this.getStockData[i];

      const centralTotalStock = stockItem?.central_total_stock ?? 0;
        data.push({          
          y: this.getRandomNumber(0, 10000, this.stockAmount[i]),
        });
    }

    const chart = Highcharts.chart('chart-stock' as any, {
      title: {
        text: 'Stock'
      },
      chart: {
        type: 'column',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      
      yAxis: {
        min: 0,
        title: undefined,
      },
      xAxis: {
        categories: this.DateUTList.map((item: { date: any; }) => item.date),
      },
      tooltip: {
        // headerFormat: `<div>Date: {point.key}</div>`,
        headerFormat: '',
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        },
      series: [{
        name: 'Amount',
        data,
 color: '#006637'
      }],
    } as any);
  }
}


selectedYear: any ='';
selectedState: any ='';
content_apiresponse:any;
  sucess_message:any;
  status:any;

  years: any=[];
getStockList(State:any,SYear:any,start:any,limit:any,currentPage:any){
  // getStockDatay(SYear:any,start:any,limit:any,currentPage:any){
    let param = {
      'state':State,
      'year':SYear
    }
    this.fciwebservice.getStockData(param,'getStockWebsiteData').subscribe((response:any) => {
      this.content_apiresponse = response;
      let respData = this.content_apiresponse.RESPONSE_DATA;
      let respToken = this.content_apiresponse.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response);
        
        this.getStockData = response.result;      
        // console.log(this.getStockData);
        this.createChartColumn();
        
      }
      
    });
  //  }
}

private generateYears(startYear: number, endYear: number): number[] {
  const years: number[] = [];
  for (let year = startYear; year >= endYear; year--) {
    years.push(year);
  }
  return years;
}

onStateSelected(): void {
  this.getStockList(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
}

onYearSelected(): void {

  this.getStockList(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
  
}

pageChanged(page: any) {

  let param_arr = []; 
  let category,fyear;
  category="";
  fyear="";

  
  this.currentPage=page;
  this.start=(this.currentPage - 1)*this.limit;
  // this.getStockList(category,fyear,this.start,this.limit,this.currentPage);
  this.getStockList(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
}

apiresponse:any;
StateUTList:any;
public  getStockStateUTList(){
  let param ={

  }
  this.fciwebservice.getStockStateUTList(param).subscribe((response:any) => {

     switch (response.type) { 
      case HttpEventType.Sent:
        break;
      case HttpEventType.ResponseHeader:
        break;
      case HttpEventType.UploadProgress:
        break;
      case HttpEventType.Response:
        this.apiresponse = response.body;
        let respData = this.apiresponse.RESPONSE_DATA;
        let respToken = this.apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
           this.StateUTList = res.result;        
        } 
    }
  });

}
DateUTList:any;
public getStockDateUTList(){
  let param ={

  }
  this.fciwebservice.getStockDateUTList(param).subscribe((response:any) => {

     switch (response.type) { 
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.apiresponse = response.body;
        let respData = this.apiresponse.RESPONSE_DATA;
        let respToken = this.apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
           this.DateUTList = res.result;        
        } 
    }
  });

}
public mapStockDateData(stockData: any[]): any[] {
   const categories: string[] = [];
  this.DateUTList.forEach((item: { date: string; }) => {
    categories.push(item.date);
  }); 

    const amounts: number[] = [];
    
    for (const category of categories) {
      const stateData = stockData.find(item => item.date === category);
      if (stateData) {
        amounts.push(stateData.central_total_stock);
        console.log(amounts);
        
      } else {
        amounts.push(0);
      }
    }
    return amounts;
 }

 isInteger(value: number): boolean {
  return Number.isInteger(value);
}




countDecimals:any = (value:any):any =>{ 
  if ((value % 1) != 0) 
      return value.toString().split(".")[1].length;  
  return 0;
};
NumberFormart(num:any):any{
if(num=='' || num==null){
  return 0;
}
if(parseFloat(num) <= 0){
  if(this.countDecimals(num) > 5){
    return parseFloat(num).toFixed(5);
  }
  return num;
}
if(parseFloat(num)){
  if(this.countDecimals(num) > 5){
    return parseFloat(num).toFixed(5);
  }
  return num;
}
return num;
}


}


